import { useLocation } from "react-router-dom";
export default function Header() {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";
  const handleScrollToCta = () => {
    const el = document.getElementById("cta-signup");
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header>
      <div className="container nav">
        {/* Echter Seitenwechsel statt Client-Routing: "/" ist jetzt die statische
            Landingpage, die außerhalb der React-App liegt. */}
        <a href="/" className="brand" aria-label="Marke">
          <div className="logo" aria-hidden="true" />
          <span>ShowKompass</span>
        </a>

        {isLandingPage && (
          <div className="header-cta">
            <button type="button" className="btn primary" onClick={handleScrollToCta}>
              Kostenlos Testen
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
